module.exports = __webpack_public_path__ + "img/jcyj_index3.5414af11.jpg";